import { render, staticRenderFns } from "./investigacion.vue?vue&type=template&id=7a65e942&scoped=true&"
import script from "./investigacion.vue?vue&type=script&lang=js&"
export * from "./investigacion.vue?vue&type=script&lang=js&"
import style0 from "./investigacion.vue?vue&type=style&index=0&id=7a65e942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65e942",
  null
  
)

export default component.exports